var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHashTag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.8212 11C3.46157 11 3.18892 10.6756 3.25079 10.3213L4.96968 0.479426C5.01808 0.202257 5.25873 0 5.54009 0C5.89973 0 6.17238 0.324396 6.1105 0.678671L4.39162 10.5206C4.34321 10.7977 4.10257 11 3.8212 11ZM6.6169 11C6.25727 11 5.98461 10.6756 6.04649 10.3213L7.76537 0.479426C7.81378 0.202257 8.05442 0 8.33579 0C8.69543 0 8.96808 0.324397 8.9062 0.678672L7.18732 10.5206C7.13891 10.7977 6.89827 11 6.6169 11ZM10.9996 3.72837C10.9996 4.05173 10.7375 4.31387 10.4141 4.31387H2.08551C1.76214 4.31387 1.5 4.05173 1.5 3.72837C1.5 3.405 1.76214 3.14286 2.08551 3.14286H10.4141C10.7375 3.14286 10.9996 3.405 10.9996 3.72837ZM10.462 7.31696C10.462 7.64033 10.1999 7.90247 9.8765 7.90247H1.54071C1.21734 7.90247 0.955197 7.64033 0.955197 7.31696C0.955197 6.9936 1.21734 6.73146 1.54071 6.73146H9.8765C10.1999 6.73146 10.462 6.9936 10.462 7.31696Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHashTag);
export default __webpack_public_path__ + "static/media/hash-tag.79173b0220bd20367e21e7037fd1e76e.svg";
export { ForwardRef as ReactComponent };